import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class DrugATC extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition
    ) {
        super(new FormGroup({}), 
            [...fieldDefinition.atcCodeItemFields], {});
    }

}
